var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOldDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8604 6.2168V0.216797H18.8604V6.2168H10.8604ZM0.860352 10.2168V0.216797H8.86035V10.2168H0.860352ZM10.8604 18.2168V8.2168H18.8604V18.2168H10.8604ZM0.860352 18.2168V12.2168H8.86035V18.2168H0.860352ZM2.86035 8.2168H6.86035V2.2168H2.86035V8.2168ZM12.8604 16.2168H16.8604V10.2168H12.8604V16.2168ZM12.8604 4.2168H16.8604V2.2168H12.8604V4.2168ZM2.86035 16.2168H6.86035V14.2168H2.86035V16.2168Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldDashboardIcon);
export default __webpack_public_path__ + "static/media/old-dashboard-icon.756b7b021f8932c1a2a8f8932c580b11.svg";
export { ForwardRef as ReactComponent };